import { useEffect, useState } from 'react'
import RightSideDetails from "../global/rightSideDetails";
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import Select from 'react-select';
import { deleteMatBook, getMatBook, getMatGuestBookingByDate, getMatMasterAll, postMatBook, postMatBookAndCreatePayment, getMatTypeAll } from '../api/matAPI';
import { getGolfUsers, getGuestAll, getMobileCodeAll } from '../api/usersAPI';
import AddGuest from '../teeTime/addGuest';
import AddPayment from '../teeTime/addPayment';
import { checkIfJunior } from '../../assets/scripts/custom-date';
// import { getOrderByInvoiceData } from '../api/paymentAPI';
// import Loading from '../global/loading';

const appUrl = ( window.location.hostname === 'localhost') ? 'http://localhost:8080':'https://pcgc-admin.golfez.in'

const MatBookingSheet = (props) => {

    //#region States
    const [isInit, setIsInit] = useState(true);
    const [rightSideDetails, setRightSideDetails] = useState(false);
    const [selectedDate, setSelectedDate] = useState(moment().toDate());
    const [selectedMat, setSelectedMat] = useState(null);
    const [filteredMat, setFilteredMat] = useState([]);
    const [selectedMatType, setSelectedMatType] = useState(null);
    const [allMaster, setAllMaster] = useState([]);
    const [matType, setMatType] = useState([]);
    const [bookSheetList, setBookSheetList] = useState([]);
    const [bookSheet, setBookSheet] = useState({ Garmin: 0, Bucket: 1 });
    const [usersList, setUsersList] = useState([]);
    const [bookingTable, setBookingTable] = useState(null);
    const [holiday, setHoliday] = useState(null);
    const [serverTime, setserverTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));
    const [bucketOption, setBucketOption] = useState([{ value: 1, label: 1 }, { value: 2, label: 2 }]);
    const [typeOption, setTypeOption] = useState([{ value: 'User', label: 'User' }, { value: 'Guest', label: 'Guest' },]);
    const [guestList, setGuestList] = useState([]);
    const [showAddPayment, setShowAddPayment] = useState();
    const [mobileCodeList, setMobileCodeList] = useState([]);
    const [paymentTagging, setPaymentTagging] = useState({});
    const [bookingUser, setBookingUser] = useState(null);
    const [showAddGuest, setShowAddGuest] = useState(false);
    const [guestBookingList, setGuestBookingList] = useState([])
    const [dayName, setDayName] = useState('');
    const [isProceedDisabled, setIsProceedDisabled] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const [baseValues, setBaseValues] = useState({baseBucket:100, baseGarmin:100, weekday:100, weekend:200}); //fallback values - updates from API
 
    //#endregion
 
    
    //#region Effects
    
        useEffect(() => {
            props.title("Booking Sheet", "mat-sheet");
            $('#txtDate').datepicker({
                format: 'dd-mm-yyyy',
                minDate: new Date(),
            });
            $('#txtDate').on('change', function (event) {
                setSelectedDate(event.target.value)
            });
            fetchMatMasterAndType();
        }, []);
        
        useEffect(() => {
            if (selectedDate && selectedMat && selectedMatType) {
                fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID, selectedMatType.ID)
            }
            setDayName(moment(selectedDate, 'DD-MM-YYYY').format('dddd'))
        }, [selectedDate, selectedMat]);
        
        useEffect(() => {
            if (filteredMat && filteredMat.length > 0) {
                setSelectedMat(filteredMat[0])
            }
        }, [filteredMat])
    
        useEffect(() => {
            if(Array.isArray(matType) && matType.length > 0) {
                setSelectedMatType(matType[0])
            }
        }, [matType])

        useEffect(() => {
            if (selectedMatType !== null) {                
                const mat = allMaster.filter(m=>m.MatTypeID === selectedMatType.ID && m.Active == 'Y');
                setFilteredMat(mat); 
               
            }
        }, [selectedMatType])

        useEffect(() => {
            if (bookSheet.UserID && bookSheet.UserType == 'Guest') fetchMatGuestBookingByDate(bookSheet.UserID, moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }, [bookSheet])

        useEffect(() => {
            if (rightSideDetails) {
                Config.Core.OpenDrawer()
            } else {
                setBookSheet({ Garmin: 0, Bucket: 1 })
                setBookingUser(null)
                setPaymentTagging({})
                setGuestBookingList([])
            }
        }, [rightSideDetails]);

        useEffect(() => {
            if (!isInit) fillDataTable();
        }, [bookSheetList, holiday, serverTime]);

    //#endregion

    //#region Functions
        const resetUser = () => {
            setBookSheet(a => ({ ...a, UserID: '' }));
            setBookingUser(null)
        }

        const updateBookingDetails = (field, value) => {
            if (field == 'Type') {
                setBookSheet(d => {
                    if (field == 'Type' && value == 'User') {
                        return { ...d, UserID: '', [field]: value, UserType: value }
                    } else {
                        return { ...d, UserID: '', [field]: value, UserType: value }
                    }
                })
            } else {
                setBookSheet((d) => {
                    return { ...d, [field]: value, OwnerType: 'Admin' };
                });
            }
        };
    
        const fetchBookSheet = async (selectedDate, dayName, matID, matTypeID) => {
            try {
                const response = await getMatBook({selectedDate, dayName, matID, matTypeID, type: 'matBookSheet'});
                isInit ? setIsInit(false) : $('#tblBookSheet').KTDatatable().destroy(); 
                setBookSheetList(response.bookSheet);
                setHoliday(response.holiday);
                setserverTime(response.serverTimestamp);                            
                setBaseValues(response?.baseValues);
            } catch (error) {
                swal.fire({ icon :'error', titleText : error.message })
            }
        }

        const fetchMatGuestBookingByDate = async (guestID, selectedDate) => {
            try {
                const response = await getMatGuestBookingByDate(guestID, selectedDate);
                setGuestBookingList(response)
            } catch (error) {
                swal.fire({ icon: 'error', titleText: error.message })
            }
        }

        const fetchMatMasterAndType = async () => {
            try {
                const mat = await getMatMasterAll();
                setAllMaster(mat); 
                let matTypes = await getMatTypeAll();
                matTypes = Array.isArray(matTypes) ? matTypes : [];
                setMatType(matTypes); 
                const filtered = mat.filter(m=>m.MatTypeID === matTypes[0].ID && m.Active == 'Y');
                setFilteredMat(filtered);
            } catch (error) {
                swal.fire({ icon :'error', titleText : error.message })
            }
        }

        const fetchUsers = async () => {
            try {
                const users = await getGolfUsers('user');           
                setUsersList(users);
            } catch (error) {
                swal.fire({
                    icon: 'error',
                    titleText: error.message
                })
            }
        }

        const fetchGuest = async () => {
            try {
                const guests = await getGuestAll()
                const mobileCodeArr = await getMobileCodeAll()            
                setMobileCodeList(mobileCodeArr);
                setGuestList(guests);
            } catch (error) {
                swal.fire({
                    icon: 'error',
                    titleText: error.message
                })
            }
        };

        const cancelBookingHandler = async () => {
            const btn = $('#btnCancel');
            helper.StartProcessing(btn);
            try {
                await deleteMatBook(bookSheet.ID)
                helper.StopProcessing(btn);
                fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID,selectedMatType.ID)
                closeDrawer();
                swal.fire({
                    icon: 'success',
                    titleText: 'Booking deleted successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            } catch (err) {
                helper.StopProcessing(btn);
                swal.fire({
                    icon: 'error',
                    titleText: 'Error!',
                    text: err.message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }
        }

        const paymentHandler = (value) => {
            if (value.UserType == 'Guest') {
                // if(paymentTaggingList && paymentTaggingList.length > 0){
                //     setPaymentTagging(paymentTaggingList.find((f) => f.UserID == value.UserID && f.TeeTimeBookUserID == value.TeeTimeBookUserID))
                // }else{
                //     setPaymentTagging({})
                // }
                setShowAddPayment(value)
            }
        }
    
        const addBookingGuestHandler = () => {
            if (bookSheet.UserID) {
                const newO = guestList.find((f) => f.ID == bookSheet.UserID)
                setBookingUser({
                    ...newO, UserType: 'Guest',
                    })
                paymentHandler({ ...newO, UserID: bookSheet.UserID, UserType: "Guest" });
            }
        }

        const addBookingUserHandler = () => {
            if (bookSheet.UserID) {
                const newO = usersList.find((f) => f.ID == bookSheet.UserID)
                const IsJunior = checkIfJunior(newO.DOB);
                setBookingUser({
                    ...newO, UserType: 'User',
                    IsJunior
                })
            }
        }
    
        const addBookingHandler = async () => {
            const btn = $('#btnSave');
            if (bookSheet.Bucket == 0 || !bookSheet.Bucket) {
                swal.fire({
                    icon: 'warning',
                    text: "Enter number of Bucket",
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }

            if (!bookSheet.UserID) {
                swal.fire({
                    icon: 'warning',
                    text: "Please select player",
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }

            helper.StartProcessing(btn);
            try {
                await postMatBook({
                    ...bookSheet,
                    Status: "Booked",
                    MatID: selectedMat.ID,
                    Type: 'Mat',
                    EntryFee: (bookSheet.UserType == 'Guest' && (guestBookingList.length == 0 || bookSheet.EntryFee == 'Y')) ? 'Y' : 'N',
                    BookDate: moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                }, paymentTagging)
                closeDrawer();
                fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID,selectedMatType.ID)
                if (bookSheet.ID) {
                    swal.fire({
                        toast: true,
                        icon: 'success',
                        titleText: 'Booking updated successfully!',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 1500,
                        animation: false,
                        customClass: {
                            popup: 'margin-20',
                        },
                    });
                } else {
                    swal.fire({
                        icon: 'success',
                        titleText: 'Booking added successfully!',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            } catch (err) {
                helper.StopProcessing(btn);
                swal.fire({
                    icon: 'error',
                    titleText: 'Error!',
                    text: err.message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }

        }

        const handleProceedToPay = async () => {

            const btn = $('#btnSave1');
            if (bookSheet.Bucket == 0 || !bookSheet.Bucket) {
                swal.fire({
                    icon: 'warning',
                    text: "Enter number of Bucket",
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }

            if (!bookSheet.UserID) {
                swal.fire({
                    icon: 'warning',
                    text: "Please select player",
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;
            }
            helper.StartProcessing(btn);
            setIsProceedDisabled(true);
            try {
                const formattedDate = moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

                const payload = {

                    matBook: {
                        ...bookSheet,
                        OwnerType: "Admin",
                        Status: "Pending",
                        MatID: selectedMat.ID,
                        MatTypeID: selectedMatType.ID,
                        Type: 'Mat',
                        EntryFee: (bookSheet.UserType == 'Guest' && (guestBookingList.length == 0 || bookSheet.EntryFee == 'Y')) ? 'Y' : 'N',
                        BookDate: formattedDate,
                    },
                    paymentTagging,
                };

                const res = await postMatBookAndCreatePayment(payload);

                fetchBookSheet(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedDate, 'DD-MM-YYYY').format('dddd'), selectedMat.ID,selectedMatType.ID)

                closeDrawer();

                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Booking added & payment link sent successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 1500,
                    animation: false,
                    customClass: {
                        popup: 'margin-20',
                    }
                });
            } catch (err) {
                helper.StopProcessing(btn);
                console.error("Payment Error:", err);
                  swal.fire({
                    icon: 'error',
                    titleText: 'Failed to create payment link',
                    text: err.message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand',
                });
                return;              
            }
            setIsProceedDisabled(false);
        };

        const closeDrawer = () => {
            Config.Core.CloseDrawer();
            setTimeout(() => {
                setRightSideDetails(false);
            }, 200);
        }

        function exportSheet(btnType) {
            let fileName = `${moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - Mat Booking Sheet}`;

            bookingTable.update({
                headers: true,
                formats: ["xlsx", "csv"],
                filename: fileName // pass in a new set of properties
            });

            if (btnType == 'xlsx') {
                $('.button-default.xlsx').click();
            } else {
                $('.button-default.csv').click();
            }

            $('.tableexport-caption').addClass('hidden');
        }

        function fillDataTable() {
            swal.close();

            if (holiday != null) {
                $('#lblHoliday').text("Holiday : " + holiday.Name);
            } else {
                $('#lblHoliday').text("");
            }

            let columnList = [
                {
                    field: 'Slot', title: 'Slot',
                    template: function (row) {
                        return `${row.SlotFrom} To ${row.SlotTo}`
                    },
                    width: 140
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template: function (row) {
                        if (row.Status != null) {
                            return `<span class="badge badge-danger">${row.Status}</span>`
                        } else {
                            return '<span class="badge badge-success"> Available </span>'
                        }
                    },
                    width: 80,
                },
                {
                    field: 'Player',
                    title: 'Player',
                    template: function (row) {
                        if (row?.Player) {
                            return `<span class='kt-badge kt-badge--${row.UserType == "User" ? 'success' : (row.UserType == "Guest" || row.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player}`
                        } else {
                            return '';
                        }
                    },
                    width: 120,
                },
                {
                    field: 'Bucket',
                    title: ' Bucket',
                    width: 50,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? !!row?.Bucket ? row?.Bucket : '' : ''}</strong>`
                    }
                },
                {
                    field: 'Garmin',
                    title: ' Garmin',
                    width: 50,
                    template: function (row) {
                        return `<strong style="font-weight: 600"> ${row?.UserID != 0 ? (row?.Garmin == 1 ? 'Yes' : !!row?.Bucket ? 'No' : '') : ''}</strong>`
                    }
                },
                {
                    field: 'PaymentStatus',
                    title: 'Payment Status',
                    template: function (row) {
                        const statusClass = row.PaymentStatus === 'paid' ? 'success' : 'danger';
                        const displayText = row.PaymentStatus === 'paid' ? 'Paid' : (row.PaymentStatus || '-');
        
                        return `<span class="badge badge-${statusClass}">${displayText}</span>`;
                    },
                    width: 105,
                },
                // {
                //     field: 'Payment Mode',
                //     title: 'Payment Mode',
                //     template: function (row) {
                //         if (row.PaymentLinkID) {
                //             return '<span class="badge badge-success"> Online </span>';
                //         } else if (row.Comment === "") {
                //             return '<span class="badge badge-primary"> Offline </span>';
                //         } else {
                //             return '<span class="badge badge-warning"> - </span>';
                //         }
                //     },
                //     width: 100,
                // },
                {
                    field: 'Invoice',
                    title: 'Invoice',
                    template: function (row) {                                                   
                        return((row.PaymentStatus === 'paid') 
                        ? `<a  href="${appUrl}/api/invoice/getInvoiceByInvoiceNo?invoiceId=${row.InvoiceNo}" type="button" target="_blank" rel="noopener noreferrer" class="btn btn-sm p-1 btn-outline-primary download-invoice-btn" data-id="${row.InvoiceNo}"> View Invoice</a>`
                        :"");                        
                    },
                    width: 90,
                },
                {
                    field: '',
                    title: '',
                    width: 60,
                    class: "clickable",
                    template: function (row) {
                        if ((row.Status == "Available" || row.Status == "Pending" || row.Status == "Booked" || row.Status == null)) {
                            return showEditButton(row)
                        } else {
                            return '';
                        }
                    }
                },
            ]

            if(selectedMatType?.ID == 2) columnList = columnList?.filter(f =>  f.field !== 'Garmin')

            const dataTable = $('#tblBookSheet').KTDatatable({
                data: {
                    saveState: false,
                    source: bookSheetList,
                    pageSize: 20
                },
                layout: {
                    scroll: true,
                    height: $(window).height() - 250,
                    footer: false,
                },
                sortable: true,
                pagination: false,
                search: { input: $('#generalSearch') },
                columns: Array.isArray(columnList) ? columnList : [] ,
                rows: {
                    autoHide: false,
                }
            });

            $('#root .kt-grid--hor').addClass('max-width100');
            $('#tblBookSheet .kt-datatable__table').addClass('overflow-x-auto');

            Config.Core.InitPopover();
            Config.Core.GrabAndScroll('.kt-datatable__table');

            // export to excel
            const BookingTable = $('.kt-datatable__table').tableExport({
                formats: ["xlsx", "csv"],
                headers: true,
                filename: `${moment().format("DD-MM-YYYY")} - Mat Booking Sheet`,
            });
            setBookingTable(BookingTable);
            $('.tableexport-caption').addClass('hidden');

            function showEditButton(row) {

                const formattedDate = moment($('#txtDate').val(), 'DD/MM/YYYY').format('DD-MMM-YYYY');

                var optString = '';               

                const isEdit = moment(moment(serverTime.ServerDate).format('DD-MMM-YYYY')).isSameOrBefore(formattedDate);
                // const isEdit = true;

                optString += '<center>'

                if (row.Comment) optString += `<button type="button" class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs mr-1" data-toggle="kt-popover"  data-trigger="hover click" data-placement="left" data-original-title="Comments" data-content="${row.Comment}"><i class="fa fa-info"></i></button>`

                if (isEdit) optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`

                optString += '</center>'

                return optString;
            }

            // Handle download invoice button clicks
            // dataTable.on('click', '.download-invoice-btn', function(e) {
            //     e.preventDefault();
            //     return;
            //     const button = $(this);
            //     // const PaymentLinkID = button.data('id');
            //     const InvoiceId = button.data('id');
            //     // Disable button and show loading state
            //     button.prop('disabled', true);
            //     button.text('Downloading...');

            //     // Call download function
            //     generateInvoice({ InvoiceId:InvoiceId, button: button })
            // });

            // Handle edit button clicks (existing functionality)
            dataTable.on('click', '.btn-edit', function (ss) {
                const index = $(ss.currentTarget).parents('tr').index();
                setSelectedRowIndex(index);
                if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                    setBookSheet({
                        ...dataTable.dataSet[index],
                        Type: dataTable.dataSet[index].ID ? dataTable.dataSet[index].UserType : 'User',
                        UserType: dataTable.dataSet[index].ID ? dataTable.dataSet[index].UserType : 'User',
                        Bucket: dataTable.dataSet[index].Bucket ? dataTable.dataSet[index].Bucket : 1,
                        Discount: dataTable.dataSet[index].Discount === 0 ? '' : dataTable.dataSet[index].Discount,
                        Garmin: dataTable.dataSet[index]?.Garmin || 0,
                        IsJunior: dataTable.dataSet[index]?.IsJunior || 'N'
                    })
                    if (dataTable.dataSet[index].ID) {
                        setBookingUser({
                            Name: dataTable.dataSet[index].Name,
                            UserType: dataTable.dataSet[index].UserType,
                            UserID: dataTable.dataSet[index].UserID,
                            IsJunior: dataTable.dataSet[index]?.IsJunior || 'N'
                        })
                    }
                    if (dataTable.dataSet[index].UserType == 'Guest') {
                        setPaymentTagging({
                            ReferenceID: dataTable.dataSet[index].ReferenceID,
                            ReferenceType: dataTable.dataSet[index].ReferenceType,
                            PaymentMode: dataTable.dataSet[index].PaymentMode,
                            ReferenceNumber: dataTable.dataSet[index].ReferenceNumber,
                            TagTo: dataTable.dataSet[index].TagTo,
                        })
                    }
                    fetchUsers();
                    fetchGuest();
                    setRightSideDetails(true);
                }
            });

            // Return the dataTable instance for external use
            return dataTable;
        }

        const deleteUserHandler = () => {
            setBookingUser(null)
        }
    
        const getDayType = (dayName, matTypeID, holiday) => {   
            if(matTypeID == 2)
                return (dayName === 'Monday')  /**@desc - For holiday Use Normal */
            else
                return (dayName === 'Sunday' || dayName === 'Saturday' || dayName === 'Friday' || holiday) 
        }

    //#endregion

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content" >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label padding-l30 text-right">Date </label>
                                    <div className="form-group col-xs-2 col-sm-2">
                                        <div className="input-group date">
                                            <input
                                                id="txtDate"
                                                name="txtDate"
                                                type="text"
                                                className="form-control"
                                                placeholder="Select date"
                                                defaultValue={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label text-right ml-3 mr-2">MatType </label>
                                    <div className="form-group col-xl-2 col-sm-2 p-0">
                                        <Select
                                            onChange={(event) => setSelectedMatType(event.value)}
                                            name="ddlMatType"
                                            value={(selectedMatType && (Array.isArray(matType) && matType.length > 0)) && {label : selectedMatType.Type, value: selectedMatType}}
                                            id="ddlMatType"
                                            className="ddlMatType"
                                            options={Array.isArray(matType) ? matType.map(c => ({
                                                label: `${c.Type}`,
                                                value: c
                                            })) : []}
                                        />
                                    </div>
                                    <label className="col-form-label text-right padding-l30">Mat </label>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <Select
                                            onChange={(event) => setSelectedMat(event.value)}
                                            name="ddlMat"
                                            value={(selectedMat && (filteredMat && filteredMat.length > 0)) && {label : selectedMat.Number, value: selectedMat}}
                                            id="ddlMat"
                                            className="ddlMat"
                                            options={
                                                Array.isArray(filteredMat)
                                                  ? filteredMat?.map(c => ({
                                                      label: `${c.Number}`,
                                                      value: c
                                                    }))
                                                : []
                                            }
                                            isDisabled={!selectedMatType}
                                        />
                                    </div>
                                    <div className="form-group col-xl-2 col-sm-2">
                                        <div className="input-group ">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input
                                                    type="text"
                                                    className="form-control clientSearch"
                                                    placeholder="Search..."
                                                    id="generalSearch"
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-1 col-sm-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{ position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)' }}>
                                                <button
                                                    id="btn-export-excel"
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}
                                                > Excel
                                                </button>
                                                <button
                                                    id="btn-export-csv"
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                > Csv
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h5 id="lblHoliday" className="lblHoliday"></h5>
                            <div id="tblBookSheet" className="table table-bordered table-hover custom-datatable"></div>
                            {rightSideDetails &&
                                <RightSideDetails title={`Mat Booking ${' - ' + selectedMatType?.Type || ''}` } onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body padding-t30 padding-b0">
                                            <form id="ModalHolder" className="kt-form kt-form--label-right padding-10">
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Date</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input
                                                            id="lblDate"
                                                            disabled="disabled"
                                                            name="lblDate"
                                                            type="text"
                                                            className="form-control"
                                                            value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlSlot" className="form-group row">
                                                    <label className="col-form-label col-lg-3">Slots</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <input
                                                            id="lblSlot"
                                                            disabled="disabled"
                                                            name="lblSlot"
                                                            type="text"
                                                            onChange={updateBookingDetails}
                                                            className="form-control"
                                                            value={`${bookSheet.SlotFrom} To ${bookSheet.SlotTo}`}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="pnlType" className="form-group row">
                                                    <label className="col-form-label col-lg-3">
                                                        Type <span className="red"></span>
                                                    </label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <div>
                                                            <Select
                                                                id="ddlType"
                                                                name="ddlType"
                                                                className="multi-custom"
                                                                placeholder="Select Type"
                                                                isDisabled={bookingUser ? true : false}
                                                                value={
                                                                    bookSheet && bookSheet.Type
                                                                        ? { label: bookSheet.Type, value: bookSheet.Type }
                                                                        : typeOption?.[0]
                                                                            ? { label: typeOption[0].label, value: typeOption[0].value }
                                                                            : ''
                                                                }
                                                                onChange={(event) => updateBookingDetails('Type', event.value)}
                                                                options={typeOption || []}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {bookSheet.Type == "User" ? (
                                                    <div id="UserHolder">
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">User</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group" >
                                                                    <div style={{ width: "60%" }}  >
                                                                        <Select
                                                                            value={(usersList && usersList.length > 0 && bookSheet.UserID) && { label: `${usersList.find(m => m.ID == bookSheet.UserID).Name} (${usersList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID } || ''}
                                                                            onChange={(event) => updateBookingDetails('UserID', event.value)}
                                                                            name="ddlUser"
                                                                            placeholder="Select User"
                                                                            isDisabled={bookingUser ? true : false}
                                                                            id="ddlUser"
                                                                            className="ddlUser"
                                                                            options={usersList.map(c => ({
                                                                                label: `${c.Name} (${c.Mobile})`,
                                                                                value: c.ID
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                   
                                                                    <div className="input-group-append" style={{ zIndex: 0 }}>
                                                                        <button className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}   disabled={
                                                                            !!bookSheetList?.[selectedRowIndex]?.PaymentStatus &&
                                                                            ["paid", "created"].includes(bookSheetList[selectedRowIndex].PaymentStatus)
                                                                            }><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    {!bookingUser && (
                                                                        <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={addBookingUserHandler}>Add</button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div id="GuestHolder" >
                                                        <div className="form-group row">
                                                            <label className="col-form-label col-lg-3">Guest</label>
                                                            <div className="col-xl-6 col-lg-8">
                                                                <div className="input-group">
                                                                    <div style={{ width: "60%" }}  >
                                                                        <Select
                                                                            value={(guestList && guestList.length > 0 && bookSheet.UserID) && { label: `${guestList.find(m => m.ID == bookSheet.UserID).Name} (${guestList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID }}
                                                                            onChange={(event) => updateBookingDetails('UserID', event.value)}
                                                                            name="ddlGuest"
                                                                            placeholder="Select Guest"
                                                                            isDisabled={bookingUser ? true : false}
                                                                            id="ddlGuest"
                                                                            // isDisabled={bookingUser ? true : false}
                                                                            data-live-search="true"
                                                                            className="ddlGuest"
                                                                            options={guestList.map(c => ({
                                                                                label: `${c.Name} (${c.Mobile})`,
                                                                                value: c.ID
                                                                            }))}
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append" disabled={bookingUser ? true : false} style={{ zIndex: 0 }}>
                                                                        <button

                                                                            className="btn btn-secondary kt-select-reset" type="button" onClick={resetUser}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                                    </div>
                                                                    {!bookingUser && (
                                                                        <button id="btnAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={addBookingGuestHandler}>Add</button>
                                                                    )}
                                                                    <button id="btnNewGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest" onClick={() => setShowAddGuest(true)} >New</button>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Bucket</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <Select
                                                            id="ddlBucket"
                                                            name="ddlBucket"
                                                            className="multi-custom"
                                                            placeholder="Select Bucket"
                                                            isDisabled={
                                                                    !!bookSheetList?.[selectedRowIndex]?.PaymentStatus &&
                                                                    ["paid", "created"].includes(bookSheetList[selectedRowIndex].PaymentStatus)
                                                                }
                                                            defaultValue={bookSheet?.Bucket && bucketOption.length > 0 && { label: `${bucketOption.find(m => m.label == bookSheet.Bucket).label}`, value: bookSheet.Bucket } || ''}
                                                            onChange={(event) => updateBookingDetails('Bucket', event.value)}
                                                            options={bucketOption}
                                                        />
                                                    </div>
                                                </div>
                                                { selectedMatType?.ID != 2 && <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Garmin</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <span className="kt-switch kt-switch--icon">
                                                            <label>
                                                                <input
                                                                    id="chkActive"
                                                                    name="chkActive"
                                                                    type="checkbox"
                                                                    disabled={["paid", "created"].includes(bookSheetList[selectedRowIndex].PaymentStatus)}
                                                                    defaultChecked={bookSheet.Garmin != 1 ? '' : 'checked'}
                                                                    onChange={(event) => updateBookingDetails('Garmin', event.target.checked ? 1 : 0)}
                                                                />
                                                                <span></span>
                                                            </label>
                                                        </span>
                                                    </div>
                                                </div>}
                                                <div className="form-group row">
                                                    <label className="col-form-label col-lg-3">Comment</label>
                                                    <div className="col-xl-6 col-lg-8">
                                                        <textarea
                                                            id="txtComment"
                                                            name="txtComment"
                                                            className="form-control"
                                                            rows="3"
                                                            value={bookSheet.Comment || ''}
                                                            // disabled={["paid", "created"].includes(bookSheetList[selectedRowIndex].PaymentStatus)}
                                                            onChange={(event) => updateBookingDetails('Comment', event.target.value)}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </form>
                                            <table id="table-user" className="table table-bordered table-hover margin-b30">
                                                <thead className="light-grey-background" >
                                                    <tr>
                                                        <th>Players</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                {bookingUser &&
                                                    <tbody>
                                                        <tr>
                                                            <td onClick={() => { paymentHandler(bookingUser) }}>
                                                                <span className={`kt-badge kt-badge--${bookingUser.UserType == "User" ? 'success' : (bookingUser.UserType == "Guest" || bookingUser.UserType == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}>
                                                                </span>&nbsp; &nbsp;{bookingUser.Name}{bookingUser.UserType == "Guest" && ` (G) - ${paymentTagging?.TagTo || 'Direct'}`}
                                                            </td>
                                                            <td>
                                                                <center>
                                                                    {bookSheetList[selectedRowIndex].PaymentStatus !== "paid" && bookSheetList[selectedRowIndex].PaymentStatus !== "created" && 
                                                                    <button className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10 btn-user-delete" type="button" onClick={deleteUserHandler} >
                                                                        <i className="flaticon2-rubbish-bin-delete-button"></i>
                                                                    </button>
}
                                                                </center>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                }
                                                <tfoot></tfoot>
                                            </table>
                                            <table id="table-tax" className="table table-bordered table-hover margin-b30" style={{ flex: 1 }}>
                                                <thead className="light-grey-background">
                                                    <tr>
                                                        <th>Description</th>
                                                        <th className="text-right">Amount (₹ )</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(bookSheet.UserType == 'Guest' && (guestBookingList.length == 0 || bookSheet.EntryFee == 'Y')) && (
                                                        <tr>
                                                            <td>Entry Fee</td>
                                                            {/* <td className="text-right">₹  {( holiday || ['Friday', 'Saturday', 'Sunday'].includes(dayName)) ? baseValues?.weekend : baseValues?.weekday}</td> */}
                                                            {/* let isholiday = holiday || matBook.MatTypeID == 2 ? ( day == 1) : ( day == 0 || day >= 5); */}
                                                            <td className="text-right">₹  {getDayType(dayName, selectedMatType?.ID, holiday) ? baseValues?.weekend : baseValues?.weekday}</td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td>{bookSheet.Bucket + ' Bucket'} </td>
                                                        <td className="text-right">₹  {bookSheet?.Bucket * (bookingUser?.IsJunior === 'Y' ? baseValues?.baseBucketForJR : baseValues?.baseBucket) }</td>
                                                    </tr>
                                                    {selectedMatType?.ID != 2 && <tr>
                                                        <td>Garmin</td>
                                                        <td className="text-right">₹  {bookSheet?.Garmin == 1 ? (1 * baseValues?.baseGarmin) : '0'}</td>
                                                    </tr>}
                                                    <tr>
                                                        <td><strong>Total</strong></td>
                                                        {(bookSheet.UserType == 'Guest' && (guestBookingList.length == 0 || bookSheet.EntryFee == 'Y')) ? (
                                                            <td className="text-right"><strong>₹  {(bookSheet?.Bucket * (bookingUser?.IsJunior === 'Y' ? baseValues?.baseBucketForJR : baseValues?.baseBucket)) + (bookSheet?.Garmin == 1 ? (1 * baseValues?.baseGarmin) : 0) + (getDayType(dayName, selectedMatType?.ID, holiday) ? baseValues?.weekend : baseValues?.weekday)}</strong><br /><small>(incl. GST)</small></td>
                                                        ) : (
                                                            <td className="text-right"><strong>₹  {(bookSheet?.Bucket * (bookingUser?.IsJunior === 'Y' ? baseValues?.baseBucketForJR : baseValues?.baseBucket)) + (bookSheet?.Garmin == 1 ? (1 * baseValues?.baseGarmin) : 0)}</strong><br /><small>(incl. GST)</small></td>
                                                        )}
                                                    </tr>
                                                </tbody>
                                                <tfoot></tfoot>
                                            </table>
                                        </div>
                                        <div className="kt-portlet__foot">
                                            <div className="kt-form__actions">
                                                <div className="row">
                                                    <div className="col-lg-12 text-right">
                                                        {/* {bookSheetList[selectedRowIndex].PaymentStatus !== "paid" && bookSheetList[selectedRowIndex].PaymentStatus !== "created" && (
                                                            <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{bookSheet.ID ? 'Update Booking' : 'Save Booking'}</button>
                                                        )} */}

                                                        {(!!bookSheet?.ID) && <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addBookingHandler}>{'Update Booking'}</button>}
                                                        
                                                        {(bookSheet.ID) && <button id="btnCancel" type="button" className="btn btn-warning d-inline-block margin-l10" onClick={cancelBookingHandler}>Cancel Booking</button>}

                                                        {(!bookSheetList[selectedRowIndex]?.Status) ? (
                                                            <button
                                                                id="btnSave1" type="button" className="btn d-inline-block"
                                                                disabled={isProceedDisabled}
                                                                style={{ backgroundColor: '#FFA726', color: 'white', border: 'none', marginLeft: '10px' }}
                                                                onClick={handleProceedToPay}
                                                            >
                                                                Proceed to pay
                                                            </button>
                                                            ) : ("")
                                                        }

                                                        <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </RightSideDetails>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {showAddGuest && (
                <AddGuest
                    show={showAddGuest}
                    onDismissModal={setShowAddGuest}
                    setShowAddPayment={setShowAddPayment}
                    mobileCodeList={mobileCodeList}
                    fetchGuest={() => fetchGuest()}
                    from='mat'
                // bookingUserList={bookingUserList}
                />
            )}
            {(showAddPayment && Object.keys(showAddPayment).length !== 0) && (
                <AddPayment
                    show={showAddPayment}
                    MemberDetails={showAddPayment}
                    onDismissModal={setShowAddPayment}
                    setPaymentTagging={setPaymentTagging}
                    paymentTagging={paymentTagging}
                    MemberList={usersList}
                />
            )}
        </>
    )
}

export default MatBookingSheet;
